import { DropdownField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../common/state';
import { EPublishPeriod, IJsonQueryTerm } from '../../../../json_query';
import { changePublishPeriod } from '../../../state/advanced/publish_period';
import { InlineParam, Row } from '../markup';

export interface IPublishPeriodProps {
  publishPeriod: IJsonQueryTerm<EPublishPeriod> | undefined;
  onChanged(value: EPublishPeriod): void;
}

export const publishPeriod: React.StatelessComponent<IPublishPeriodProps> = props => (
  <Row title="Дата публикации объявлений">
    <InlineParam>
      <DropdownField
        value={(props.publishPeriod && props.publishPeriod.value) || 0}
        onValueChange={(value: EPublishPeriod) => props.onChanged(value)}
        values={[
          { value: EPublishPeriod.Any, label: 'За любую дату' },
          { value: EPublishPeriod.Today, label: 'Сегодня' },
          { value: EPublishPeriod.Hour, label: 'За час' },
          { value: EPublishPeriod.Day, label: 'За сутки' },
          { value: EPublishPeriod.TenDays, label: 'За 10 дней' },
          { value: EPublishPeriod.Month, label: 'За месяц' },
        ]}
      />
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    publishPeriod: state.filters.jsonQuery.publish_period,
  }),
  (dispatch: Dispatch) => ({
    onChanged: (value: EPublishPeriod) => {
      dispatch(changePublishPeriod(value));
    },
  }),
)(publishPeriod);
